module.exports = __webpack_public_path__ + "static/media/aa.f2247ef2.png";